import { createAction } from '@reduxjs/toolkit';
import { GetPricesForOneNftReq } from 'types/requests';
import actionTypes from './actionTypes';

// eslint-disable-next-line max-len
export const getPricesForOneNft = createAction<GetPricesForOneNftReq>(actionTypes.GET_PRICES_FOR_ONE_NFT);
